import React, { useEffect, useState } from "react";

const DimensionCalculator = ({ children }) => {
  const [height, setHeight] = useState(0);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const updateDimensions = () => {
      if (containerRef.current) {
        const containerHeight = containerRef.current.clientHeight;
        const containerWidth = containerRef.current.clientWidth;
        setHeight(containerHeight);
        setWidth(containerWidth);
      }
    };

    updateDimensions();
    window.addEventListener("resize", updateDimensions);

    return () => {
      window.removeEventListener("resize", updateDimensions);
    };
  }, []);

  const containerRef = React.useRef(null);

  return <div ref={containerRef}>{children({height, width})}</div>;
};

export default DimensionCalculator;
